import { render, staticRenderFns } from "./LegacyStatsModal.vue?vue&type=template&id=354064ba&"
import script from "./LegacyStatsModal.vue?vue&type=script&lang=js&"
export * from "./LegacyStatsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports